import React, { useEffect } from 'react';
import { logout } from 'state/session/actions';
import { connect, useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';

const LogoutPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(logout());
  }, [dispatch]);

  return <Redirect to="/login" />;
};

export default connect()(LogoutPage);
